export class CostTranshipmentParams {
    page = 1;
    limit = 10;
    fromDate?: number;
    toDate?: number;
}
